export default __webpack_public_path__ + "static/Toyota_Desktop_Typography_Body_Weight-1dd3379e284c34d091a418b16d3988a1.svg";